import { ReactElement } from 'react';
import styles from './PayForm.module.scss';

interface iPayForm {
  obligationNumber: string;
}

const PayForm = ({ obligationNumber }: iPayForm): ReactElement => {
  const { REACT_APP_SITECORE_API_ENDPOINT: API_URL } = process.env;

  return (
    <form name="payForm" action={`${API_URL}sitecore/Payment/Pay`} method="POST">
      <input type="hidden" name="identifier" value={obligationNumber} />
      <input type="submit" name="payFine" value="Pay your fines" className={`${styles.button} ${styles.blue} ${styles.medium}`} />
    </form>
  );
};
export default PayForm;
